import type { SortField } from '../types';

const sorts: SortField[] = [
  {
    label: 'Relevance',
    index: 'score',
    direction: 'desc'
  },
  {
    label: 'Number',
    index: 'ss_field_report_number',
    direction: 'desc'
  },
  // {
  //   label: 'Published Date',
  //   index: 'ds_created',
  //   direction: 'desc'
  // },
  // {
  //   label: 'Updated Date',
  //   index: 'ds_changed'
  // },
  // {
  //   label: 'Item ID',
  //   index: 'item_id',
  //   direction: 'asc'
  // },
  {
    label: 'Node ID',
    index: 'its_nid',
    direction: 'asc'
  },
  {
    label: 'Title',
    index: 'tm_X3b_und_title',
    direction: 'asc'
  }
];

export default sorts;
